/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Solid_Civil_Wasp_AdaptInputs */

const fr_solid_civil_wasp_adapt = /** @type {(inputs: Solid_Civil_Wasp_AdaptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrondi`)
};

/**

* @param {Solid_Civil_Wasp_AdaptInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const solid_civil_wasp_adapt = /** @type {((inputs?: Solid_Civil_Wasp_AdaptInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Solid_Civil_Wasp_AdaptInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_solid_civil_wasp_adapt(inputs)
});